import { render, staticRenderFns } from "./TestQuestions.vue?vue&type=template&id=4bd7ca2d&scoped=true&"
import script from "./TestQuestions.vue?vue&type=script&lang=js&"
export * from "./TestQuestions.vue?vue&type=script&lang=js&"
import style0 from "./TestQuestions.vue?vue&type=style&index=0&id=4bd7ca2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd7ca2d",
  null
  
)

export default component.exports